import type { CustomerRow } from "design-components";

/** Page size for operator customers list API (`fromIndex` / `toIndex` window). */
export const CUSTOMERS_LIST_PAGE_SIZE = 50;

export interface CustomerEditDrawerInitialValues {
  companyName: string;
  primaryContactName: string;
  primaryContactEmail: string;
  /** Optional; prefill when edit DTO includes `phone` (AV-185). */
  phone: string;
  primaryBusinessAddress: string;
  locationIds: number[];
}

export interface CustomerForEditPrefill {
  initialValues: CustomerEditDrawerInitialValues;
  locationOptions: Array<{ value: string; label: string }>;
}

export interface CustomersListState {
  rows: CustomerRow[];
  totalCustomers: number;
  loading: boolean;
  error: string | null;
  search: string;
  /** Empty = all locations; otherwise filter by these location ids. */
  locationFilterIds: string[];
  fromIndex: number;
  toIndex: number;
  sortingField: string;
  sortingOrder: "asc" | "desc";
  listFilterStatus: string[];
  deleteSubmitting: boolean;
  deleteError: string | null;
  /** Invite or update customer drawer submit in flight. */
  formSubmitting: boolean;
  /** Edit drawer prefill fetch in flight. */
  editPrefillLoading: boolean;
  showOnlyActive: boolean;
  operatorFilterIds: string[];
}

export const customersListInitialState: CustomersListState = {
  rows: [],
  totalCustomers: 0,
  loading: false,
  error: null,
  search: "",
  locationFilterIds: [],
  fromIndex: 0,
  toIndex: CUSTOMERS_LIST_PAGE_SIZE,
  sortingField: "status",
  sortingOrder: "asc",
  listFilterStatus: [],
  deleteSubmitting: false,
  deleteError: null,
  formSubmitting: false,
  editPrefillLoading: false,
  showOnlyActive: false,
  operatorFilterIds: [],
};
